import { useEffect } from "react";
import { numToCurrency, decimToPercent } from "../utils/transformators";
import * as Calculations from "../utils/calculations";
import useSPPosition from "../../../hooks/useSPPosition";
import { useLocation } from "react-router-dom";

const useCalculationsSP = (positionData, paymenttermData) => {
  //General
  const location = useLocation();
  // Load context values
  const { setSPposition, setSPpositionData, positiontoeditSP } = useSPPosition();

  useEffect(() => {
    const docalcs = async () => {
      // totalinboundcalc
      let ttloutbound = await Calculations.sumvalues(
        positionData.outdrayage,
        positionData.loading,
        positionData.outcollectcharges,
        positionData.outboundothers
      );
      // outboundpmtcalc
      const outbpmt = await Calculations.dividevalues(ttloutbound, positionData?.outpayload);
      //  materialvaluecalc
      const matvalue = await Calculations.multiplyvalues(positionData.quantity, positionData.materialcost);
      // totaldutycalc
      const ttlduty = await Calculations.sumvalues(positionData.generaldutyimp, positionData.additionaldutyimp);
      // dutyfeecalc
      const dtyfee = await Calculations.multiplyvalues(matvalue, ttlduty);
      // harborfeecalc
      const hbrfee = await Calculations.multiplyvalues(matvalue, positionData.harborfeepct);
      // merchprocfeecalc
      const mrcfee = await Calculations.multiplyvalues(matvalue, positionData.merchprocfeepct);
      // totalcentryfeecalc
      const ttlcentryfee = await Calculations.sumvalues(
        dtyfee,
        hbrfee,
        mrcfee,
        positionData.flatfee,
        positionData.tsca,
        positionData.isf
      );
      // centryfeepmtcalc
      const centrypmt = await Calculations.dividevalues(ttlcentryfee, positionData.quantity);
      // totalinboundcalc
      const ttlinbound = await Calculations.sumvalues(
        positionData.indrayage,
        positionData.unloading,
        positionData.incollectcharges,
        positionData.inboundothers
      );
      // inboundpmtcalc
      const inbpmt = await Calculations.dividevalues(ttlinbound, positionData.inpayload);
      // freightpmtcalc
      const frtpmt = await Calculations.dividevalues(positionData.oceanfreight, positionData.oceanpayload);
      // totalcostcalc
      const ttlcost = await Calculations.sumvalues(
        positionData.materialcost,
        outbpmt,
        centrypmt,
        inbpmt,
        positionData.pcomission,
        positionData.pfinancecost,
        frtpmt,
        positionData.inspectioncost,
        positionData.legal,
        positionData.pallets,
        positionData.other
      );
      console.log(positionData.interest);
      // insurcalc
      const inscost = await Calculations.multiplyvalues(
        ttlcost,
        positionData.insurancerate,
        positionData.insurancefactor
      );
      // interestcostcalc
      const intercost = await Calculations.interestcostcalc(ttlcost, paymenttermData, positionData?.interest);
      // finalpricecalc
      const paii = await Calculations.sumvalues(ttlcost, intercost, inscost);

      setSPposition((prev) => ({
        ...prev,
        ["totalcost"]: numToCurrency(ttlcost),
        ["interestcost"]: numToCurrency(intercost),
        ["insurancecost"]: numToCurrency(inscost),
        ["priceafterintins"]: numToCurrency(paii),
        ["materialvalue"]: numToCurrency(matvalue),
        ["totalduty"]: decimToPercent(ttlduty),
        ["dutyfee"]: numToCurrency(dtyfee),
        ["harborfee"]: numToCurrency(hbrfee),
        ["merchprocfee"]: numToCurrency(mrcfee),
        ["totalcentryfee"]: numToCurrency(ttlcentryfee),
        ["importcustomsfee"]: numToCurrency(centrypmt),
        ["totalinbound"]: numToCurrency(ttlinbound),
        ["inboundcost"]: numToCurrency(inbpmt),
        ["totaloutbound"]: numToCurrency(ttloutbound),
        ["outboundcost"]: numToCurrency(outbpmt),
        ["freightpmt"]: numToCurrency(frtpmt),
      }));
      setSPpositionData((prev) => ({
        ...prev,
        ["totalcost"]: ttlcost,
        ["interestcost"]: intercost,
        ["insurancecost"]: inscost,
        ["priceafterintins"]: paii,
        ["materialvalue"]: matvalue,
        ["totalduty"]: ttlduty,
        ["dutyfee"]: dtyfee,
        ["harborfee"]: hbrfee,
        ["merchprocfee"]: mrcfee,
        ["totalcentryfee"]: ttlcentryfee,
        ["importcustomsfee"]: centrypmt,
        ["totalinbound"]: ttlinbound,
        ["inboundcost"]: inbpmt,
        ["totaloutbound"]: ttloutbound,
        ["outboundcost"]: outbpmt,
        ["freightpmt"]: frtpmt,
      }));
    };
    docalcs();
  }, [
    positionData.generaldutyimp,
    positionData.additionaldutyimp,
    positionData.quantity,
    positionData.materialcost,
    positionData.pcomission,
    positionData.pfinancecost,
    positionData.freightpmt,
    positionData.inspectioncost,
    positionData.legal,
    positionData.pallets,
    positionData.other,
    positionData.interest,
    paymenttermData,
    positionData.insurancefactor,
    positionData.insurancerate,
    positionData.harborfeepct,
    positionData.merchprocfeepct,
    positionData.flatfee,
    positionData.tsca,
    positionData.isf,
    positionData.indrayage,
    positionData.unloading,
    positionData.incollectcharges,
    positionData.inboundothers,
    positionData.inpayload,
    positionData?.outdrayage,
    positionData?.loading,
    positionData?.outcollectcharges,
    positionData?.outboundothers,
    positionData?.outpayload,
    positionData.oceanfreight,
    positionData.oceanpayload,
    positiontoeditSP,
    location.key,
  ]);
  return <div>useCalculationsSP</div>;
};

export default useCalculationsSP;
